import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import Popover from '@mui/material/Popover';
import { popoverStyle } from './popoverStyle.tailwind';
import profile from '../../../../assets/svgs/dummy_image.svg';
import logoutIcon from '../../../../assets/svgs/logout.svg'
import MyAccount from '../../../../assets/svgs/edit-profile.svg'
import { logout } from '../../../../redux/slices/authSlice';
import routeConstant from '../../../../lib/constants/routeConstant';
import { filterString } from '../../../../lib/constants/globalConstant';
import { profileData } from './profilePopover.data';
import { setMyAccountActiveTab } from '../../../../redux/slices/publicSlice';
import { MY_ACCOUNT_TABS } from '../../../MyAccount/myAccountTabsData';
import OverlayLoader from '../../Loaders/OverlayLoader/OverlayLoader';
import SeasonDropDown from '../../../SeasonDropDown/SeasonDropDown';


// Profile Popover
const ProfilePopover = ({ anchorEl, onClose, getLoggedOut, redirectToMyAccount, showSeasonDropdown, setSeasonUpdating }) => {
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const id = open ? 'profile-popover' : undefined;

    const { loggingOut } = useSelector(state => state.auth)
    const { user } = useSelector(state => state.user)

    const [errorLoadingProfileImage, setErrorLoadingProfileImage] = useState(false);


    // handle Logout Function
    const handleLogout = async () => {
        if(loggingOut) return;

        const resultAction = await getLoggedOut();
        // if logout slice is fulfilled
        if (logout.fulfilled.match(resultAction)) {
          navigate(`${routeConstant.LOGIN_PAGE}`); // navigate back to login page
        }
    };

    // handle MyAccount Function
    const handleMyAccount = () => {
        navigate(`${routeConstant.MY_ACCOUNT_PAGE}`); // navigate to MyAccount page
        redirectToMyAccount()
        onClose();
    };

    if (loggingOut) {
        return <OverlayLoader />;
    }
    
    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            disableScrollLock={true} //disables automatically scrolling-LOCK
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px"
                    }
                }
            }}
        >
            {/* Popover Body */}
            <div className={popoverStyle.popoverContent}>
                {/* header */}
                <div className={popoverStyle.profileHeader}>
                    {/* <Link to={routeConstant.MY_ACCOUNT_PAGE}> */}
                        <figure>
                            {user?.userDetails?.profileImageUrl && !errorLoadingProfileImage ? (
                                <img 
                                    src={user?.userDetails?.profileImageUrl} 
                                    alt="Profile" className={popoverStyle.profileImage} 
                                    onError={() => setErrorLoadingProfileImage(true)}
                                />
                            ) : (
                                <img 
                                    src={profile} // Fallback image
                                    alt="Profile" 
                                    className={popoverStyle.profileImage} 
                                />
                            )}
                        </figure>
                    {/* </Link> */}
                    {user?.userDetails?.userNickName && (
                        // <Link to={routeConstant.MY_ACCOUNT_PAGE} className={popoverStyle.profileName}>
                            <span className={popoverStyle.profileName}>{filterString(user?.userDetails?.userNickName)}</span>
                        // </Link>
                    )}
                </div>

                {/* All Other tabs */}
                <div className={popoverStyle.popover_tabs}>
                    {/* Dropdown */}
                    {showSeasonDropdown && (<div className='flex screen-850:hidden'>
                        <SeasonDropDown darkTheme={true} setSeasonUpdating={setSeasonUpdating} />
                    </div>)}
                    
                    {/* My Account Tab */}
                    <div className={popoverStyle.popover_tab} onClick={handleMyAccount}>
                        <figure>
                            <img src={MyAccount} alt="My Account" className={popoverStyle.iconImages} />
                        </figure>
                        <div className={popoverStyle.tab_text}>My Account</div>
                    </div>

                    {/* Other Page Links */}
                    {profileData?.map((tab, key) => (
                        <Link to={tab?.link} key={key} onClick={onClose} className={popoverStyle.popover_tab}>
                            <figure>
                                <img src={tab?.icon} alt={tab?.title} className='w-[20px]' />
                            </figure>

                            <div className={popoverStyle.tab_text}>{tab?.title}</div>
                        </Link>
                    ))}

                    {/* Logout tab */}
                    <div className={`${loggingOut && popoverStyle.popover_tab_disabled} ${popoverStyle.popover_tab}`} onClick={handleLogout}>
                        <figure>
                            <img src={logoutIcon} alt={"Logout"} className='w-[20px]' />
                        </figure>

                        <div className={popoverStyle.tab_text}>{loggingOut ? `Logging Out...` : `Logout`}</div>
                    </div>
                </div>
            </div>
        </Popover>
    );
};

const mapDispatchToProps = (dispatch) => ({
    getLoggedOut: (data) => dispatch(logout(data)),
    redirectToMyAccount: () => dispatch(setMyAccountActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB)),
});

export default connect(null, mapDispatchToProps)(ProfilePopover);